
export const UserActions = {
  SET_USER: 'setUser',
  SET_EMAIL_ADDRESS: 'setEmailAddress',
  SET_EMAIL_VERIFIED: 'setEmailVerified',
  SET_ACCOUNT_ID: 'setAccountId',
};

export const setUser = (user) => ({
  type: UserActions.SET_USER,
  payload: user,
});

export const setEmailAddress = (emailAddress) => ({
  type: UserActions.SET_EMAIL_ADDRESS,
  payload: emailAddress,
});

export const setAccountId = (accountId) => ({
  type: UserActions.SET_ACCOUNT_ID,
  payload: accountId,
});

export const setEmailVerified = (verified = true) => ({
  type: UserActions.SET_EMAIL_VERIFIED,
  payload: verified,
});
